module.exports = __webpack_public_path__ + "static/media/hdaLogo.e81646c3.png";